
import React, { useEffect } from "react"
import { Helmet } from "react-helmet"
import AOS from "aos";
import "aos/dist/aos.css"
import { BrowserRouter } from "react-router-dom"
import AppRouter from "./router/AppRouter";
import ScrollToTop from "./components/ScrollToTop";




function App() {

  useEffect(() => {
    AOS.init({
      duration: 1200,
    });
  }, []);

  return (
    <div className="App">
      <Helmet
        defaultTitle="CuySoft – Innovación Tecnológica y Educación en Ecuador"
        titleTemplate="%s | CuySoft"
      >
        <html lang="es" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="keywords" content="CuySoft, innovación tecnológica Ecuador, desarrollo de software, ciberseguridad, educación tecnológica, soluciones IT, desarrollo web, transformación digital, consultoría tecnológica, software empresarial" />
        <meta name="description"
          content="CuySoft – Empresa ecuatoriana especializada en innovación tecnológica, desarrollo de software, ciberseguridad y educación digital. Soluciones IT para empresas en Ecuador." />
        <meta name="author" content="CuySoft" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.cuysoft.com/" />
        <meta property="og:locale" content="es_EC" />
        <meta property="og:site_name" content="CuySoft" />
        <meta property="og:url" content="https://www.cuysoft.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="CuySoft – Innovación Tecnológica y Educación en Ecuador" />
        <meta property="og:description" content="Empresa ecuatoriana líder en desarrollo de software, ciberseguridad, innovación tecnológica y educación digital." />
        <meta property="og:image" content="https://www.cuysoft.com/assets/img/ogg.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CuySoft – Innovación Tecnológica y Educación en Ecuador" />
        <meta name="twitter:description" content="Empresa ecuatoriana líder en desarrollo de software, ciberseguridad, innovación tecnológica y educación digital." />
        <meta name="twitter:image" content="https://www.cuysoft.com/assets/img/ogg.png" />
      </Helmet>
      <ScrollToTop />
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </div>
  );
}

export default App;
